import * as React from 'react';

interface EventContextProps {
    category: string
}

export const EventContext: React.Context<EventContextProps> = React.createContext({ category: 'default category' });

export const EventProvider: React.FunctionComponent<EventContextProps> = ({ children, category: newCategory }) => {
  const { category } = React.useContext(EventContext);
  const newValue = { category: newCategory || category };
  return <EventContext.Provider value={newValue}>{children}</EventContext.Provider>;
};
